import React from 'react';
import Link from 'next/link';
import {
    ProgramInfoTitle,
    ProgramInfoTitleLink,
    ProgramInfoEpisodeLink,
    ProgramInfoDivider,
} from './ProgramInfo.styles';
// import TopBarVariants from './TopBarVariants';
import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import {
    trackModalTitle,
    trackModalEpisode,
    trackModalAccessibilityVariant,
} from 'app/utils/statistics/customEvents';
import TopBarVariants from './TopBarVariants';
import { useDispatch } from 'react-redux';
import { updateAccessVersionChoice } from 'app/actions/videoPage';

const ProgramInfo = ({
    title,
    episodeTitle,
    url,
    videos,
    selectedVideoId,
    parentUrl,
}: {
    title: string;
    episodeTitle: string;
    url: string;
    videos: Array<{
        accessibility: string;
        svtId: string;
        name: string;
        urls: { svtplay: string };
    }>;
    selectedVideoId: string;
    parentUrl: string;
}) => {
    const dispatch = useDispatch();

    if (!title || !episodeTitle) {
        return null;
    }

    const updateAccessibilityVersion = (accessibility: string) => {
        dispatch(updateAccessVersionChoice(accessibility));
    };

    const variants = videos?.filter((video) => video.svtId && video.svtId !== selectedVideoId);

    const trackTitleClick = (e) => {
        trackCustomEvent(trackModalTitle(selectedVideoId));
    };

    const trackEpisodeClick = (e) => {
        trackCustomEvent(trackModalEpisode(selectedVideoId));
    };

    const trackAccessabilityVariantClick = (variant) => {
        trackCustomEvent(trackModalAccessibilityVariant(variant));
    };

    return (
        <>
            <ProgramInfoTitle data-rt="program-info-title">
                <Link
                    href={{
                        pathname: parentUrl,
                    }}
                    passHref
                >
                    <ProgramInfoTitleLink data-rt="title-link" onClick={trackTitleClick}>
                        {title}
                    </ProgramInfoTitleLink>
                </Link>

                {title !== episodeTitle && (
                    <>
                        <ProgramInfoDivider />
                        <Link
                            href={{
                                pathname: url,
                            }}
                            passHref
                        >
                            <ProgramInfoEpisodeLink onClick={trackEpisodeClick} data-rt="episode-link">
                                {episodeTitle}
                            </ProgramInfoEpisodeLink>
                        </Link>
                    </>
                )}
            </ProgramInfoTitle>
            <TopBarVariants
                variants={variants}
                onClick={(version) => {
                    trackAccessabilityVariantClick(version);
                    updateAccessibilityVersion(version);
                }}
            />
        </>
    );
};

export default ProgramInfo;
